export default {
	"components.WeChat": "WeChat",
	"components.Alipay": "Alipay",
	"components.ScanCodeToPay": "Scan code to pay",
	"components.SaveQRCode": "Save QR code",
	"components.detectedThatYouAreNotInstalled": "detected that you are not installed",
	"components.PleaseInstall": ", please install"
}